// extracted by mini-css-extract-plugin
module.exports = {"container":"CustomerOrders_container__1hifj","instructions":"CustomerOrders_instructions__3Dv0V"};